export { default as Divider, type DividerProps } from './Divider';
